import { getStartedCompany } from 'api/calls';
import { LinkedInUser } from 'components/types';
import { useState, useEffect, createContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ContextProviderProps, StepperContextCorporateType } from '../../../../types/Context';
import { OptionTypes, Reasons, Option } from '../../../../types/types';
import { MultiValue } from 'react-select';


const initialState: StepperContextCorporateType = {
    // data
    levels: [],
    setLevels: () => { },
    departments: [],
    setDepartments: () => { },

    // user Info
    linkedInId: "",
    setLinkedInId: () => { },
    firstName: "",
    setFirstName: () => { },
    lastName: "",
    setLastName: () => { },
    email: "",
    setEmail: () => { },
    sectors: [],
    setSectors: ()=>{},
    reasons: [],
    setReasons: ()=>{},
    reasonsDescription: undefined,
    setReasonsDescription: ()=>{},
    reasonsHasDescription:undefined,
    setReasonsHasDescription:()=>{},
    password: "",
    setPassword: () => { },
    confirmPassword: "",
    setConfirmPassword: () => { },
    guestID:undefined, 
    setGuestID: () => { },
    //Corporate Info
    companyName: "",
    setCompanyName: () => { },
    country: "",
    setCountry: () => { },
    city: "",
    setCity: () => { },
    department: { value: "", label: "" },
    setDepartment: () => { },
    level: { value: "", label: "" },
    setLevel: () => { },
    jobTitle: "",
    setJobTitle: () => { },
    termsChecked: false,
    setTermsChecked: () => { },
    privacyChecked: false,
    setPrivacyChecked: () => { },
    cityOption:{ value: "", label: "" } ,
    setCityOption: () => { },
}

export const CorporateStepperContext = createContext<StepperContextCorporateType>(initialState);

export const CorporateStepperContextProvider = ({ children }: ContextProviderProps) => {
    const { state } = useLocation();
    const linkedInUser = state as LinkedInUser | undefined

    // data
    const [levels, setLevels] = useState<OptionTypes[]>([])
    const [departments, setDepartments] = useState<OptionTypes[]>([])

    // user Info
    const [linkedInId, setLinkedInId] = useState(linkedInUser?.id ?? "")
    const [firstName, setFirstName] = useState( "")
    const [lastName, setLastName] = useState( "")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [guestID, setGuestID]= useState<string | undefined>()
    const [sectors, setSectors] = useState<MultiValue<OptionTypes>>([])
    const [reasons, setReasons] = useState<MultiValue<OptionTypes>>([])
    const [reasonsDescription, setReasonsDescription] = useState<string | undefined>()
    const [reasonsHasDescription,setReasonsHasDescription] = useState<boolean | undefined>()

    //Corporate Info
    const [companyName, setCompanyName] = useState("")
    const [country, setCountry] = useState(initialState.country)
    const [city, setCity] = useState(initialState.city)
    const [cityOption, setCityOption]= useState<OptionTypes>({ value: "", label: "" })
    const [department, setDepartment] = useState<OptionTypes>({ value: "", label: "" })
    const [level, setLevel] = useState<OptionTypes>({ value: "", label: "" })
    const [jobTitle, setJobTitle] = useState("")
    const [termsChecked, setTermsChecked] = useState(false)
    const [privacyChecked, setPrivacyChecked] = useState(false)

    useEffect(() => {
        getStartedCompany()
            .then(({ response }) => {
                if (!response) return
                setLevels(response.levels);
                setDepartments(response.departments);
            })
    }, [])

    useEffect(() => {
        if(linkedInUser){
            setFirstName(linkedInUser?.firstName);
            setLastName(linkedInUser?.lastName);
        }
    }, [linkedInUser])

    const corporateStepperCtx: StepperContextCorporateType = {
        // data
        levels, setLevels,
        departments, setDepartments,

        // user Info
        linkedInId, setLinkedInId,
        firstName, setFirstName,
        lastName, setLastName,
        email, setEmail,
        sectors,  setSectors,
        reasons,setReasons,
        reasonsDescription,setReasonsDescription,
        reasonsHasDescription, setReasonsHasDescription,
        password, setPassword,
        confirmPassword, setConfirmPassword,
        guestID, setGuestID,
        //Corporate Info
        companyName, setCompanyName,
        country, setCountry,
        city, setCity,
        department, setDepartment,
        level, setLevel,
        jobTitle, setJobTitle,
        termsChecked, setTermsChecked,
        privacyChecked, setPrivacyChecked,
        cityOption, setCityOption
    }


    return (
        <CorporateStepperContext.Provider value={corporateStepperCtx}>
            {children}
        </CorporateStepperContext.Provider>
    )

}



